module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer_ai"
  }, [_c('p', [_vm._v("相关链接： "), _c('a', {
    attrs: {
      "href": "/contact_us/company_produce",
      "target": "_blank"
    }
  }, [_vm._v("关于我们")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "/contact_us/contact_us",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")]), _vm._v("\n        | "), _c('a', {
    attrs: {
      "href": "/contact_us/safety-payment",
      "target": "_blank"
    }
  }, [_vm._v("汇款账号")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "http://sc.sd235.com/",
      "target": ""
    }
  }, [_vm._v("免费素材")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "/APP",
      "target": "_blank"
    }
  }, [_vm._v("APP下载")])]), _vm._v(" "), _c('p', [_vm._v("业务部总机： 028-8664-1863 值班人员手机：136-9964-5470")]), _vm._v(" "), _c('p', [_vm._v("蜀ICP备14021078号-1 | 川公网安备51010602000255号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0095231e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sdFooter.vue
// module id = 841
// module chunks = 1